module.exports = __webpack_public_path__ + "img/auth2.fd053a6.svg";